import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import { useAuthContext } from '../../context/authContext';

/**
 * La lista para la difusión manual.
 *
 * El número no se guarda en ningún lado: se vuelve a preguntar cada vez,
 * porque entre el sábado y el domingo pasados 108 clientes entraron a elegir y
 * dejaron de necesitar el mensaje.
 */
export default function useDifusion() {
  const { token, baseUrl } = useAuthContext();

  const [estado, setEstado] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  const cargar = useCallback(() => {
    setError('');
    return axios.get(`${baseUrl}admin/avisos/difusion`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => setEstado(r.data?.data ?? r.data ?? null))
      .catch((e) => {
        const codigo = e?.response?.status;
        setError(codigo === 401 || codigo === 403
          ? 'Tu sesión no tiene permiso para bajar la lista.'
          : 'No pudimos calcular a cuántos les toca. Intenta de nuevo.');
      })
      .finally(() => setCargando(false));
  }, [token, baseUrl]);

  useEffect(() => { cargar(); }, [cargar]);

  /* El navegador no abre el archivo solo: hay que pedirlo con el token, y lo
     que vuelve es el contenido, no una dirección que se pueda visitar. */
  const descargar = useCallback((momento, incluirRepetidos = false) =>
    axios.get(`${baseUrl}admin/avisos/difusion/csv`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { momento, incluirRepetidos },
      responseType: 'blob',
    }).then((r) => {
      const nombre = /filename="?([^"]+)"?/.exec(r.headers['content-disposition'] || '');
      const url = window.URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = nombre ? nombre[1] : `avisos-${momento}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      return {
        incluidos: Number(r.headers['x-incluidos'] ?? 0),
        omitidos: Number(r.headers['x-omitidos'] ?? 0),
      };
    }), [token, baseUrl]);

  return { estado, cargando, error, recargar: cargar, descargar };
}
